export const QUESTIONS_LOAD_BATCH_SIZE = 20;
export const initialPaginationOffset = 0;
